export class IntervalWorker<T = void> {

    private intervalId: ReturnType<typeof setInterval> | null = null;
    private isRunning: boolean = false;
    public value: T | undefined;

    constructor(public readonly name: string, private interval: number, public readonly callback: () => T | Promise<T>, startImmediately: boolean = true) {
        if (startImmediately) this.start();
    }

    start(warnOnRestart: boolean = true) {
        if (this.intervalId !== null) {
            if (warnOnRestart) console.warn(`IntervalWorker ${this.name} is already running, not restarting.`);
        } else {
            this.intervalId = setInterval(this.executeCallback.bind(this), this.interval);
        }
    }

    getInterval() {
        return this.interval;
    }

    setInterval(durationMs: number) {
        if (this.intervalId !== null) {
            console.debug(`Stopping IntervalWorker ${this.name}`);
            clearInterval(this.intervalId);
            this.intervalId = null;
        }
        this.interval = durationMs;
        this.start();
    }

    private async executeCallback() {
        // console.debug(`Executing IntervalWorker ${this.name} callback`);

        // Skip this execution if the previous one is still running
        if (this.isRunning) {
            console.warn(`Interval callback for worker ${this.name} is still running, skipping this execution.`);
            return;
        }

        // Reset the running state before executing the callback
        try {
            this.isRunning = true;
            this.value = await this.callback();
        } catch (error) {
            console.error(`Error in interval worker ${this.name} callback:`, error);
            this.value = undefined;
        } finally {
            this.isRunning = false;
        }
    }

    stop() {
        if (this.intervalId !== null) {
            console.debug(`Stopping IntervalWorker ${this.name}`);
            clearInterval(this.intervalId);
            this.intervalId = null;
        }
        this.value = undefined;
    }

    static schedule<T>(name: string, interval: number, callback: () => T | Promise<T>, startImmediately: boolean = true): IntervalWorker<T> {
        return new IntervalWorker<T>(name, interval, callback, startImmediately);
    }
}
